import { Navigate, Outlet, NavLink } from "react-router-dom";
import { useSelector } from 'react-redux';

export const HomeLayout = () => {
  const user = useSelector((state) => state.auth.user);
  //console.log('[HomeLayout] user =', user);

  return (
    <div style={{ paddingBottom: '50px' }}>
      <Outlet />
    </div>
  )
};
